import React from 'react';

export default function DateInput({ name, value, onChange, readOnly, required, style }) {
  const iso = value ? value.slice(0, 10) : '';

  return (
    <input
      type="date"
      name={name}
      value={iso}
      onChange={onChange}
      readOnly={readOnly}
      required={required}
      style={{ ...(readOnly ? { background: '#f3f4f6', cursor: 'not-allowed' } : {}), ...style }}
    />
  );
}

export function formatDateDMY(val) {
  if (!val) return '';
  const d = new Date(val);
  if (isNaN(d)) return '';
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}
